import { oneOf } from '~/common/utils';
const deadStatuses = ['canceled', 'past_due', 'unpaid'];
export const isAiPackage = (pkg) => pkg.name.startsWith('AIV');
export const isSerpPackage = (pkg) => pkg.name.startsWith('PACKAGE') && pkg.keywords_tracked >= 50;
export const isFree5Subscription = (sub) => sub.is_free_plan && sub.package === 5;
export const isAiSubscriptionAlive = (sub) => {
    return !!sub && !deadStatuses.includes(sub.status);
};
export const isSerpSubscriptionAlive = (sub) => {
    return !!sub && !deadStatuses.includes(sub.status) && !isFree5Subscription(sub);
};
export const isTrialEligible = (pkg) => pkg?.keywords_tracked === 200 && pkg?.cycle === 'daily';
// todo: remove this.$route.query.expire_post_trial once we are confident there are no links
// with trial=false and expire_post_trial=true
export const hasTrialInParams = (query) => !!(query.expire_post_trial || query.trial);
export const switchUpdateCycle = oneOf('daily', 'weekly');
export const switchBillingCycle = oneOf('monthly', 'annually');
export const skipNotifyingAboutNoSubscription = { value: false };
